import React, { useState, useEffect } from "react";

const CountDownCustom = ({ targetDate }) => {
    
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const enteredDate = new Date(targetDate);
            const differenceInMillis = enteredDate - now;

            const hoursLeft = Math.max(differenceInMillis / (1000 * 60 * 60), 0);
            const time = {
                hours: Math.floor(hoursLeft),
                minutes: Math.floor((hoursLeft * 60) % 60),
                seconds: Math.floor((hoursLeft * 60 * 60) % 60),
            };

            if (hoursLeft > 0) {
                setTimeLeft(time);
            } else {
                clearInterval(interval); // Stop the countdown when the time is up
            }
        }, 1000);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [targetDate]);

    return (
        <div>
            {timeLeft ? (
                <>
                    {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
                </>

            ) : ''
            }
        </div>
    );
};

export default CountDownCustom;
